import React from "react";
import styled from "styled-components";
import {
  Card,
  CardContent,
  CardHeader,
  CardHeaderTextTitle,
} from "../../organisms/dashboard/Card";
import {
  LogActividad,
  useObtenerUltimosLogsActividades,
} from "../../../services/logActividadesServicios";
import { Spinner } from "react-bootstrap";

function Activities() {
  const {
    data: logsActividades,
    isLoading: logsActividadesIsLoading,
    isSuccess: logsActividadesIsSuccess,
  } = useObtenerUltimosLogsActividades();

  return (
    <div className="col-lg-5 col-md-12">
      <ActivitiesCard className="card">
        <CardHeader className="card-header card-header-text">
          <CardHeaderTextTitle className="card-title">
            Actividad
          </CardHeaderTextTitle>
        </CardHeader>
        <CardContent className="card-content">
          {logsActividadesIsSuccess &&
            logsActividades &&
            logsActividades.length > 0 && (
              <div className="steamline">
                {logsActividades.map((actividad) => {
                  switch (actividad.nivel) {
                    case "COMUN": {
                      return (
                        <ActividadComun
                          actividad={actividad}
                          key={actividad.id}
                        />
                      );
                    }
                    case "IMPORTANTE": {
                      return (
                        <ActividadImportante
                          actividad={actividad}
                          key={actividad.id}
                        />
                      );
                    }
                    case "URGENTE": {
                      return (
                        <ActividadUrgente
                          actividad={actividad}
                          key={actividad.id}
                        />
                      );
                    }
                    default: {
                      return (
                        <ActividadComun
                          actividad={actividad}
                          key={actividad.id}
                        />
                      );
                    }
                  }
                })}
              </div>
            )}
          {logsActividadesIsLoading && <Spinner animation="border" size="sm" />}
          {logsActividadesIsSuccess &&
            logsActividades &&
            logsActividades.length === 0 && (
              <>{"No hay actividades recientes."}</>
            )}
        </CardContent>
      </ActivitiesCard>
    </div>
  );
}

const ActividadComun = ({ actividad }: { actividad: LogActividad }) => {
  return (
    <PrimarySteamLineItem className="sl-item">
      <SteamLineItemContent className="sl-content sl-primary">
        <small className="text-muted">
          {obtenerTiempoTranscurrido(actividad.segundosTranscurridos)}
        </small>
        <p>{actividad.descripcion}</p>
      </SteamLineItemContent>
    </PrimarySteamLineItem>
  );
};

const ActividadImportante = ({ actividad }: { actividad: LogActividad }) => {
  return (
    <WarningSteamLineItem className="sl-item">
      <SteamLineItemContent className="sl-content sl-warning">
        <small className="text-muted">
          {obtenerTiempoTranscurrido(actividad.segundosTranscurridos)}
        </small>
        <p>{actividad.descripcion}</p>
      </SteamLineItemContent>
    </WarningSteamLineItem>
  );
};

const ActividadUrgente = ({ actividad }: { actividad: LogActividad }) => {
  return (
    <DangerSteamLineItem className="sl-item">
      <SteamLineItemContent className="sl-content sl-danger">
        <small>
          {obtenerTiempoTranscurrido(actividad.segundosTranscurridos)}
        </small>
        <p>{actividad.descripcion}</p>
      </SteamLineItemContent>
    </DangerSteamLineItem>
  );
};

const obtenerTiempoTranscurrido = (segundos: number): string => {
  if (segundos < 60) {
    return `Hace ${Math.floor(segundos)} segundos`;
  }
  if (segundos < 3600) {
    return `Hace ${Math.floor(segundos / 60)} minutos`;
  }
  if (segundos < 86400) {
    const horas = Math.floor((segundos % (3600 * 24)) / 3600);
    const horasStr = horas === 1 ? "una hora" : `${horas} horas`;
    return `Hace ${horasStr}`;
  }
  const dias = Math.floor(segundos / (3600 * 24));
  const diasStr = dias === 1 ? "un día" : `${dias} días`;
  return `Hace ${diasStr}`;
};

const SteamLineItem = styled("div")`
  position: relative;
  padding-bottom: 12px;
  border-left: 1px solid #ccc;

  &:before {
    content: "";
    position: absolute;
    left: -6px;
    top: 0;
    background-color: #ccc;
    width: 12px;
    height: 12px;
    border-radius: 100%;
  }
`;

const PrimarySteamLineItem = styled(SteamLineItem)`
  border-left-color: ${(props) => props.theme.colors.info};
  &:before,
  last-child:after {
    background-color: ${(props) => props.theme.colors.info};
  }
`;

const DangerSteamLineItem = styled(SteamLineItem)`
  border-left-color: ${(props) => props.theme.colors.error};
  &:before,
  last-child:after {
    background-color: ${(props) => props.theme.colors.error};
  }
`;

const WarningSteamLineItem = styled(SteamLineItem)`
  border-left-color: ${(props) => props.theme.colors.warning};
  &:before,
  last-child:after {
    background-color: ${(props) => props.theme.colors.warning};
  }
`;

const SteamLineItemContent = styled("div")`
  margin-left: 24px;
  &.text-muted {
    color: inherit;
    opacity: 0.6;
    font-size: 12px;
  }
  p {
    font-size: 14px;
    color: #333;
  }
`;

const ActivitiesCard = styled(Card)`
  min-height: 100px;
`;

export default Activities;
